import React from 'react'

import type { BoxBlock as BlockProps } from '@/payload-types'
import { RenderBlocks } from '@/blocks/RenderBlocks'

export const BoxBlock: React.FC<BlockProps> = async ({ layout }) => {
  return (
    <div className={'rounded-2xl p-4 bg-primary text-white mx-auto max-w-4xl'}>
      <RenderBlocks blocks={layout ?? []} />
    </div>
  )
}
